// extracted by mini-css-extract-plugin
export default {"choice":"Choices_choice__bOLRc","majordesc":"Choices_majordesc__VdkNf"};